import loadable from "@loadable/component";

const FilterStandalone = loadable(() => import("./FilterStandalone.page"));

export default { component: FilterStandalone };
